import { LFALevelType } from '../enums';

export const LFA_LEVEL_MAP: { [key: string]: number } = {
  [LFALevelType.BEGINNER]: 1,
};
